<template>
  <div ref="container" class="container">

    <div v-if="isBlinded" style="background-color: black; width: 100%; height: 100%; position: absolute; z-index: 0;"> </div>

    <div class="component-holder" ref="componentHolder">
      <component class="content" v-bind:is="componentFile" v-bind:type="type" v-bind:page="page" ref="page" 
        v-bind:style="{transform: 'scale(' + contentScale + ')', marginLeft: marginLeft +'px', marginTop: marginTop + 'px'}"></component>
    </div>

    <!----FOOTER------------------------------------------------------------------------------------------------------------>
    <footer style="display: flex; z-index: 15" :style="[isBlinded ? {'background-color': '#FFF', 'height': footerSize + 'px'} : {'background-color': 'black', 'height': footerSize + 'px'}]">
    <!----LEFT BUTTONS-------------------------------------------------------------->
    <div style="flex-grow:1; background-color:transparent; display: flex;" :style="{width: pageWidth / 3 + 'px'}">
    <span style="position: absolute;" v-bind:style="[footerItem, footerHome]">
      <router-link :to="home" style="width:100%; height:100%;" alt="">
        <img v-if="isBlinded" src="/pages/img/svgHomeButtonBlind.svg" alt="Volver al inicio" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
        <img v-else src="/pages/img/svgHomeButtonW.svg" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
      </router-link>
    </span>
    <span style="position:absolute;" v-bind:style="[footerItem, footerLSU]" v-if="videoButtonVisible">  
      <button v-on:click="toggleVideos" style="width: 100%; height: 100%;  padding: 0px; overflow: visible;">
        <img v-if="isBlinded" src="/pages/img/svgLSUBlind.svg" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
        <img v-else src="/pages/img/svgLSU.svg" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
      </button>
    </span>
    <span style="position:absolute;" v-bind:style="[footerItem, footerLSU]" v-if="audioButtonVisible">  
      <button v-on:click="toggleAudios" style="width: 100%; height: 100%;  padding: 0px; overflow: visible;">
        <img v-if="isBlinded" src="/pages/img/svgAudioButton.svg" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
        <img v-else src="/pages/img/svgAudioButton.svg" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
      </button>
    </span>
    </div>
    <!----CENTER BUTTONS-------------------------------------------------------------->
    <div style="flex-grow:1; background-color:transparent; display: flex; flex-direction: column-reverse;" :style="{width: pageWidth / 3 + 'px'}">
      <!----PAGE INDEX-------------------------------------------------------------->
      <div style="background-color: transparent; width:100%;" v-bind:style="[footerTextContainer]">
          <p style="font-family: Open-Sans, sans-serif; text-align: center; color: black; font-weight:bold; margin: 0px" :style="[isBlinded ? {'color': 'black'} : {'color': 'white'}, footerText]">
            {{page}}
          </p>
      </div>
    </div>
    <!----RIGHT BUTTONS-------------------------------------------------------------->
    <div style="flex-grow:1; background-color:transparent; position: relative;" :style="{width: pageWidth / 3 + 'px'}">
      <span style="position:absolute;" v-bind:style="[footerItem, footerPagePrevious]">
        <router-link :to="previous" style="position:relative; width:100%; height:100%;">
          <img v-if="isBlinded" src="/pages/img/svgPreviousPageBlind.svg" alt="Página anterior" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
          <img v-else src="/pages/img/svgPreviousPageW.svg" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
        </router-link>
      </span>
      <span style="position:absolute;" v-bind:style="[footerItem, footerPageNext]">
        <router-link :to="next" style="width:100%; height:100%; position:relative;" v-if="hasNextPage">
          <img v-if="isBlinded" src="/pages/img/svgNextPageBlind.svg" alt="Página siguiente" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
          <img v-else src="/pages/img/svgNextPageW.svg" class="buttonFooter" style=" width: 100%; height: 100%; position:relative;">
        </router-link>
        <div v-else style="width:100%; height:100%; position:relative;">
          <img v-if="isBlinded" src="/pages/img/svgNextPageBlind.svg" alt="Página siguiente" class="buttonFooter" style=" width: 100%; height: 100%; position:relative; opacity: 0.3;">
          <img v-else src="/pages/img/svgNextPageW.svg" style=" width: 100%; height: 100%; position:relative; opacity: 0.3;">
        </div>
      </span>
    </div>
    </footer>
    <!----FOOTER END------------------------------------------------------------------------------------------------------------>

    <div class="videoContainer" v-if="videosVisible">

      <video controls width="250" ref="video" autoplay="true">
            <source v-bind:src="videoSrc"
              type="video/mp4">
      </video>
      <div class="videoFooter">
        <div class="videIndexContainer">
          <span v-for="(video, index) in videos" :key="video">
            <button :class="computedVideoSelectionClass(index)" v-on:click="selectedVideo = index">{{ index + 1 }}</button>
          </span>
        </div>
      </div>
      <div style="background-color: transparent;width: 100%; height: 100%;">
        
      </div>
    </div>

    <div class="audioContainer" v-if="audiosVisible">
      <audio controls width="250" ref="audio" autoplay="true">
        <source v-bind:src="audioSrc" type="audio/mpeg">
      </audio>
      <div class="audioFooter">
        <div class="videIndexContainer">
          <span v-for="(audio, index) in audios" :key="audio">
            <button :class="computedAudioSelectionClass(index)" v-on:click="selectedAudio = index">{{ index + 1 }}</button>
          </span>
        </div>
      </div>
      <div style="background-color: transparent;width: 100%; height: 100%;">
        
      </div>
    </div>
  </div>
</template>

<style>
@import '../assets/css/pageStyle.css';
</style>

<style scoped>
button
{
  background-color: Transparent;
  background-repeat:no-repeat;
  border: none;
  cursor:pointer;
  overflow: hidden;
  outline:none;
}
.container{
  display: flex;
  flex-direction: column;
  position:absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
  flex-grow: 1;
}
.component-holder {
  flex-grow: 1;
  overflow: hidden;
}
.content {
  transform-origin: 0% 0%;
}
.audioContainer {
  width:auto;
  height:auto;
  position: fixed;
  padding: 10px;
  width:300px;
  display: flex;
  flex-direction: column;
  background-color: black;
}
.audioFooter{
  background-color: black; 
  width: 100%; 
  height: auto; 
  padding-top: 5px;
  z-index: 10; 
}
.videoContainer {
  width:250px;
  height:400px;
  position: fixed;
  display: flex;
  flex-direction: column;
}
.videoFooter{
  background-color: black; 
  width: 100%; 
  height: auto; 
  margin-top: -2px; 
  z-index: 10; 
}
.videIndexContainer {
  height: auto; 
  display: block; 
  align-items: center;
  flex-direction: row;
  margin: auto;
  background-color: black;
  padding-bottom: 10px;
}
.videoIndexButton {
  background-color: black;
  color: white;
  outline: solid;
  outline-color: white;
  outline-width: 1px;
  width: 30px;
  height: 30px;
  margin-top: 10px;
  margin-left: 10px;
}
.videoIndexButtonSelected {
  background-color: white;
  color: black;
  outline: solid;
  outline-color: white;
  outline-width: 2px;
  font-weight: bold;
  width: 30px;
  height: 30px;
  margin-top: 10px;
  margin-left: 10px;
}
.buttonFooter 
{
  transform: scale(1);
  transition-duration: 0.1s;
}
.buttonFooter:hover {
  transform: scale(1.1);
}
.buttonFooter:active {
  transform: scale(0.9);
}
</style>

<script>
import interact from 'interactjs'
export default {
  name: 'Page',
  data() {
    return {
      videosEnabled:false,
      audiosEnabled:false,
      selectedVideo:0,
      selectedAudio:0,
      contentScale:1,
      marginLeft:0,
      marginTop:0,
      footerSize:0,
      pageWidth:0,
      buttonsFooterSize:0
    }
  },
  computed: {
    footerSection: function () {
      return {
        'width': window.innerWidth / 3 + 'px'
      }
    },
    footerItem: function () {
      return {
        'height': this.buttonsFooterSize + 'px',
        'width': this.buttonsFooterSize + 'px',
        'bottom': this.clamp((this.footerSize - this.buttonsFooterSize)*0.5, 0, 200) + 'px',
      }
    },
    footerText: function () {
      return {
        'font-size': this.buttonsFooterSize*0.9 + 'px'
      }
    },
    footerTextContainer: function () {
      return {
        'height': this.clamp((this.footerSize - this.buttonsFooterSize)*0.5, 0, 200) + this.buttonsFooterSize + 'px'
      }
    },
    footerHome: function () {
      return {
        'left': 30 + 'px'
      }
    },
    footerLSU: function () {
      return {
        'left': this.buttonsFooterSize + 40 + 'px'
      }
    },
    footerPageNext: function () {
      return {
        'right': 30 + 'px'
      }
    },
    footerPagePrevious: function () {
      return {
        'right': this.buttonsFooterSize + 40 + 'px'
      }
    },
    hasNextPage() {
      return this.$pageData[this.type]["pages"] > this.page;
    },
    videoSrc() {
      if (this.videoCount == 0) return "";
      return require(`../assets/videos/${this.videos[this.selectedVideo]}`);
    },
    audioSrc() {
      if (this.audioCount == 0) return "";
      return require(`../assets/audios/${this.audios[this.selectedAudio]}`);
    },
    type() {
      return this.$route.params.type;
    },
    page() {
      this.resetSelectedVideo();
      this.delayedHandleResize();
      return parseInt(this.$route.params.number);
    },
    next(){
      return "/page/" +  this.type + "/" + (this.page + 1);
    },
    previous() {
      if (this.page == 1){
        return "/"
      }
      return "/page/" +  this.type + "/" + (this.page - 1);
    },
    home() {
      return "/";
    },
    videos(){
      if (this.$pageData[this.type] === undefined) return [];
      if (this.$pageData[this.type][this.page] === undefined) return [];
      if (this.$pageData[this.type][this.page]["videos"] === undefined) return []; 
      return this.$pageData[this.type][this.page]["videos"];    
    },
    videoCount() {
      return this.videos.length;
    },
    videoButtonVisible() {
      return this.videoCount > 0 ;
    },
    videosVisible() {
      return this.videoCount > 0 && this.videosEnabled;
    },
    audioCount() {
      return this.audios.length;
    },
    audios() {
      if (this.$pageData[this.type] === undefined) return [];
      if (this.$pageData[this.type][this.page] === undefined) return [];
      if (this.$pageData[this.type][this.page]["audios"] === undefined) return []; 
      return this.$pageData[this.type][this.page]["audios"];  
    },
    audiosVisible() {
      return this.audioCount > 0 && this.audiosEnabled;
    },
    audioButtonVisible() {
      return this.audioCount > 0 ;
    },
		componentFile() {
      // We use an intermediate function because apparently
      // computed values don't check inside functions for changes
      // taken from https://forum.vuejs.org/t/dynamic-components-with-dynamic-imports/20703/12
			return this.importComponent(this.type, this.page);
		},
    isBlinded () {
      return this.type == "vision" ;
    },
  },
  methods: {
    resetSelectedVideo () {
      this.selectedVideo = 0;
      this.selectedAudio = 0;
    },
    clamp(num, min, max) {
      return num <= min ? min : num >= max ? max : num;
    },
    computedVideoSelectionClass (selectedIndex) {
      let className = 'videoIndexButton';
      if (selectedIndex == this.selectedVideo)
        className = 'videoIndexButtonSelected';
      return className;
    },
    computedAudioSelectionClass (selectedIndex) {
      let className = 'videoIndexButton';
      if (selectedIndex == this.selectedAudio)
        className = 'videoIndexButtonSelected';
      return className;
    },
    importComponent(type, page) {
      return () => import(`./pages/${type}/${page}.vue`)
    },
    toggleVideos() {
      this.videosEnabled = !this.videosEnabled;
    },
    toggleAudios() {
      this.audiosEnabled = !this.audiosEnabled;
    },
    delayedHandleResize() {
      setTimeout(() => this.handleResize(), 500);
    },
    handleResize() {
      var referenceWidth = 1024;
      var referenceHeight = referenceWidth/(4/3);
      var viewportWidth = this.$refs.componentHolder.clientWidth;
      var viewportHeight = window.innerHeight;

      this.footerSize = this.clamp(viewportHeight * 0.11, 30, 80);
      var pageHeight =  viewportHeight - this.footerSize;
      var minPageWidth = pageHeight*(4/3);

      if (minPageWidth > viewportWidth){
        this.contentScale = viewportWidth/referenceWidth;
        this.footerSize = this.clamp((this.$refs.container.clientHeight - (referenceHeight*this.contentScale))/2.0, 80, 1000);
        this.marginTop = (this.$refs.componentHolder.clientHeight - referenceHeight*this.contentScale);
        if (viewportHeight - this.$refs.componentHolder.clientHeight <= 30){
          this.marginTop = this.marginTop/2;
        }
        this.marginLeft = 0.0;
      }
      else{
        this.contentScale = pageHeight/referenceHeight;
        this.marginTop = 0;
        this.marginLeft = (this.$refs.componentHolder.clientWidth - referenceWidth*this.contentScale)/2.0;
      }  

      this.buttonsFooterSize = this.clamp(this.footerSize * 0.7, 0, 80);
      if (this.buttonsFooterSize * 5 > viewportWidth * 0.7) {
        this.buttonsFooterSize = viewportWidth * 0.7 / 5;
      } 
    }
  },
  watch: {
    videoSrc() {
      if (this.$refs.video === undefined) return;
      this.$refs.video.load();
      this.$refs.video.play();
    },
    audioSrc() {
      if (this.$refs.audio === undefined) return;
      this.$refs.audio.load();
      this.$refs.audio.play();
    },
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted(){
    window.addEventListener('resize', () => { this.handleResize(); this.delayedHandleResize(); })
    this. $nextTick(function () {
        this.handleResize();
        this.delayedHandleResize();
    })
    function dragMoveListener (event) {
      var target = event.target
      // keep the dragged position in the data-x/data-y attributes
      var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

      // translate the element
      target.style.webkitTransform =
        target.style.transform =
          'translate(' + x + 'px, ' + y + 'px)'

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
    }
    interact('.audioContainer')
      .draggable({
        // enable inertial throwing
        inertia: true,
        // keep the element within the area of it's parent
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: 'parent',
            endOnly: true
          })
        ],
        // enable autoScroll
        autoScroll: true,

        listeners: {
          // call this function on every dragmove event
          move: dragMoveListener,
        }
      })    
    interact('.videoContainer')
      .draggable({
        // enable inertial throwing
        inertia: true,
        // keep the element within the area of it's parent
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: 'parent',
            endOnly: true
          })
        ],
        // enable autoScroll
        autoScroll: true,

        listeners: {
          // call this function on every dragmove event
          move: dragMoveListener,
        }
      })
  }
}
</script>